// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  background-color: #FFFFFF; /* White Background */
}

.AppBar {
  background-color: #002855; /* Dark Blue */
}

.MuiTabs-vertical .MuiTab-root {
  color: #002855; /* Dark Blue */
  text-transform: none;
  font-size: 1rem;
  padding: 10px 20px;
}

.MuiTabs-vertical .MuiTab-root.Mui-selected {
  background-color: #FFC72C; /* Yellow */
  color: #002855;
}

.button-primary {
  background-color: #002855; /* Dark Blue */
  color: #FFFFFF;
  font-weight: bold;
  border-radius: 5px;
}

.button-primary:hover {
  background-color: #FFC72C; /* Yellow */
  color: #002855;
}

.input-field {
  border: 1px solid #F5F5F5; /* Light Gray border */
  border-radius: 5px;
  padding: 10px;
  width: 100%;
  font-size: 16px;
  margin-bottom: 20px;
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #F5F5F5;
}

.login-card {
  background-color: #FFFFFF;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  width: 400px;
  text-align: center;
}

.login-header {
  color: #002855;
  margin-bottom: 20px;
}

.login-logo {
  margin-bottom: 20px;
  border-radius: 50%;
  /* background-color: #FFC72C; */
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,iCAAiC;EACjC,yBAAyB,EAAE,qBAAqB;AAClD;;AAEA;EACE,yBAAyB,EAAE,cAAc;AAC3C;;AAEA;EACE,cAAc,EAAE,cAAc;EAC9B,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,WAAW;EACtC,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,cAAc;EACzC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,WAAW;EACtC,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;EACjD,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;AACf","sourcesContent":["body {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  background-color: #FFFFFF; /* White Background */\n}\n\n.AppBar {\n  background-color: #002855; /* Dark Blue */\n}\n\n.MuiTabs-vertical .MuiTab-root {\n  color: #002855; /* Dark Blue */\n  text-transform: none;\n  font-size: 1rem;\n  padding: 10px 20px;\n}\n\n.MuiTabs-vertical .MuiTab-root.Mui-selected {\n  background-color: #FFC72C; /* Yellow */\n  color: #002855;\n}\n\n.button-primary {\n  background-color: #002855; /* Dark Blue */\n  color: #FFFFFF;\n  font-weight: bold;\n  border-radius: 5px;\n}\n\n.button-primary:hover {\n  background-color: #FFC72C; /* Yellow */\n  color: #002855;\n}\n\n.input-field {\n  border: 1px solid #F5F5F5; /* Light Gray border */\n  border-radius: 5px;\n  padding: 10px;\n  width: 100%;\n  font-size: 16px;\n  margin-bottom: 20px;\n}\n\n.login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: #F5F5F5;\n}\n\n.login-card {\n  background-color: #FFFFFF;\n  padding: 40px;\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  width: 400px;\n  text-align: center;\n}\n\n.login-header {\n  color: #002855;\n  margin-bottom: 20px;\n}\n\n.login-logo {\n  margin-bottom: 20px;\n  border-radius: 50%;\n  /* background-color: #FFC72C; */\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
